jQuery(function ($) {

    $('.booking-form form').on("submit", function (event) {
        //modifico destinazione del form
        var urlBookingForm = $(this).find('#url-booking-form').val();
        if(urlBookingForm.length > 0) {
            $(this).attr('action', urlBookingForm);

            //adeguo il campo Guest
            var guestsValue = $(this).find('#guests_fake').val();
            $(this).find('#guests').val('{"n_adu":' + guestsValue + '}');
        }else{
            return false;
        }
    });

        const bookingForm = document.querySelector('.booking-form');
        if (!bookingForm) return;
        
        const inputCheckIn = bookingForm.querySelector('#date_from');
        const inputCheckOut = bookingForm.querySelector('#date_to');
        
        if (!inputCheckOut || !inputCheckIn) return;
        
        inputCheckIn.addEventListener('change', (e) => {
            const currentDate = new Date(e.target.value);
            if (isNaN(currentDate)) return; // Verifica se la data è valida
        
            // Aggiungi un giorno alla data di check-in
            const nextDay = new Date(currentDate);
            nextDay.setDate(currentDate.getDate() + 1);
        
            // Imposta la data di check-out nel formato corretto (YYYY-MM-DD)            
            inputCheckOut.value = nextDay.toISOString().split('T')[0];
        });

});